
import React from 'react';
import ImageGallerymediaid from '../components/ImageGallerymediaid';
import ImageGalleryeducaid from '../components/ImageGalleryeducaid';
import IMAGEGALLERYIRC_PATHFINDERR from '../components/IMAGEGALLERYIRC_PATHFINDERR';
import IRCTVDonationCard from "./IRCTVDonationCard";


const IRCMEDICAL = () => {
  const medicalaidBaseAmount = 900;


    return (
        <>
            <div className="about-us-container">
                {/* Detailed Activities Section */}
                {/* Detailed Activities Section */}
                <section className="activities-details">
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            marginBottom: '10px',
                            padding: '8px 10px',
                            backgroundColor: '#255fe8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        ← Back to All Activities
                    </button>
                    <div className="activity-intro">
                        <h2>IRC MEDICAL AID, IRC EDUCATIONAL AID & IRC EMPLOYMENT AID</h2>
                        <p>IRC provides medical, educational and employment aid for the needy and underprivileged people of the society</p>
                    </div>
                    <ImageGallerymediaid />

                    {/* IRC Medical Aid */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>IRC MEDICAL AID</h3>
                        </div>
                        <div className="activity-content">
                            <div className="aid-card">
                                <p>Our medical aid program includes:</p>
                                <ul>
                                    <li>Free medication</li>
                                    <li>Medical guidance and counselling</li>
                                    <li>Financial aid for medical expenses</li>
                                    <li>Provision of prosthetic limbs (legs/hands)</li>
                                    <li>Other essential medical services</li>
                                </ul>
                            </div>
                        </div>
                        <IRCTVDonationCard
                            title="IRC MEDICAL AID"
                            subtitle="Your donation makes a difference"
                            baseAmount={medicalaidBaseAmount}
                            description="Donate Us continue providing quality content and services to our community."
                            amount="10000"
                            purpose="Cause: IRC MEDICAL AID"
                        />
                    </div>

                    <ImageGalleryeducaid />

                    {/* IRC Educational Aid */}
                    <div className="activity-card" style={{ marginTop: '30px' }}>
                        <div className="activity-header">
                            <h3>IRC EDUCATIONAL AID</h3>
                        </div>
                        <div className="activity-content">
                            <div className="aid-card">
                                <p>Our educational support services include:</p>
                                <ul>
                                    <li>Career guidance</li>
                                    <li>Financial aid for college/course fee payment</li>
                                    <li>Assistance with purchasing books and study materials</li>
                                    <li>Help with examination fees</li>
                                    <li>Educational counseling and mentorship</li>
                                </ul>
                            </div>
                        </div>
                        <IRCTVDonationCard
                            title="IRC EDUCATIONAL AID"
                            subtitle="Your donation makes a difference"
                            description="Donate Us continue providing quality content and services to our community."
                            amount="₹5000"
                            purpose="Cause: IRC EDUCATIONAL AID"
                        />
                    </div>

                    {/* IRC Employment Aid */}
                    <div className="activity-card" style={{ marginTop: '30px' }}>
                        <div className="activity-header">
                            <h3>IRC EMPLOYMENT AID</h3>
                        </div>
                        <div className="activity-content">
                            <div className="aid-card">
                                <p>Our employment assistance program provides:</p>
                                <ul>
                                    <li>Financial aid for setting up small scale businesses</li>
                                    <li>Vocational training programs</li>
                                    <li>Micro-finance support</li>
                                    <li>Business mentorship and guidance</li>
                                </ul>
                                <p style={{ fontStyle: 'italic', marginTop: '15px' }}>
                                    Allaah is the best of providers - Alhamdulillaah, IRC is one of His chosen sources to provide help to the needy.
                                </p>
                            </div>
                        </div>
                        <IRCTVDonationCard
                            title="IRC EMPLOYMENT AID"
                            subtitle="Your donation makes a difference"
                            description="Donate Us continue providing quality content and services to our community."
                            amount="₹115000"
                            purpose="Cause: IRC EMPLOYMENT AID"
                        />
                    </div>

                    <IMAGEGALLERYIRC_PATHFINDERR />

                    {/* Women Empowerment Programs */}
                    <div className="activity-card">
                        <div className="activity-header">
                            <h3>
                                IRC PATHFINDER
                            </h3>
                        </div>
                        <div className="activity-content">
                            <p>

                                IRC conducts career guidance/counselling programs by the name of IRC PathFinder for youth and students regularly to guide them in choosing right faculties and professional courses and streams for their higher education. This has been a great source of creating awareness and enthusiasm for education amongst students (especially girls), to motivate them to pursue higher studies.
                            </p>

                            <p>
                                The IRC Career Guidance Notice Board displays notices of various exams, scholarships & advertisements of local & international job vacancies.


                            </p>
                        </div>
                        <IRCTVDonationCard
                            title="IRC PATHFINDER"
                            subtitle="Your donation makes a difference"
                            description="Donate Us continue providing quality content and services to our community."
                            amount="₹5000"
                            purpose="Cause: IRC PATHFINDER"
                        />
                    </div>

                </section>
            </div>

            <div className="testimonial-section" style={{ marginTop: '40px', textAlign: 'center' }}>
                <h3>Impact Stories</h3>
                <p>Through these aid programs, we've helped thousands of individuals regain health, continue education, and establish sustainable livelihoods.</p>
            </div>
        </>
    );
};

export default IRCMEDICAL;
